














import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { PaginationPlugin } from "bootstrap-vue";

import { Team } from "@/models/team.model";
import MyTeamsListItem from "./MyTeamsListItem.vue";

Vue.use(PaginationPlugin);

@Component({
  name: "MyTeamsList",
  components: { MyTeamsListItem }
})
export default class MyTeamsList extends Vue {
  currentPage = 1;

  @Prop({ required: true }) teams!: Team[];
  @Prop({ required: true }) total!: number;
  @Prop({ required: true }) perPage!: number;

  @Watch("currentPage")
  onCurrentPageChanged(newCurrentPage: number) {
    this.$emit("paged", newCurrentPage);
  }
}
